export default "__VITE_ASSET__JJ8z0CQveRmkF1krM5eJtA__"